export const RESET_STATE = 'RESET_STATE'
export type RESET_STATE = typeof RESET_STATE

export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS'
export type UPDATE_LOADING_STATUS = typeof UPDATE_LOADING_STATUS

export const LOAD_CHARTS = 'LOAD_CHARTS'
export type LOAD_CHARTS = typeof LOAD_CHARTS

export const LOAD_CANIS_SPEC = 'LOAD_CANIS_SPEC'
export type LOAD_CANIS_SPEC = typeof LOAD_CANIS_SPEC

export const TOGGLE_SUGGESTION = 'TOGGLE_SUGGESTION'
export type TOGGLE_SUGGESTION = typeof TOGGLE_SUGGESTION

export const UPDATE_SELECTION = 'UPDATE_SELECTION'
export type UPDATE_SELECTION = typeof UPDATE_SELECTION

export const UPDATE_DATA_TABLE = 'UPDATE_DATA_TABLE'
export type UPDATE_DATA_TABLE = typeof UPDATE_DATA_TABLE

export const UPDATE_DATA_SORT = 'UPDATE_DATA_SORT'
export type UPDATE_DATA_SORT = typeof UPDATE_DATA_SORT

export const UPDATE_DATA_ORDER = 'UPDATE_DATA_ORDER'
export type UPDATE_DATA_ORDER = typeof UPDATE_DATA_ORDER

export const UPDATE_LOTTIE = 'UPDATE_LOTTIE'
export type UPDATE_LOTTIE = typeof UPDATE_LOTTIE

export const UPDATE_LOTTIE_SPEC = 'UPDATE_LOTTIE_SPEC'
export type UPDATE_LOTTIE_SPEC = typeof UPDATE_LOTTIE_SPEC

export const UPDATE_MOUSE_MOVING = 'UPDATE_MOUSE_MOVING'
export type UPDATE_MOUSE_MOVING = typeof UPDATE_MOUSE_MOVING

export const UPDATE_KEYFRAME_TRACKS = 'UPDATE_KEYFRAME_TRACKS'
export type UPDATE_KEYFRAME_TRACKS = typeof UPDATE_KEYFRAME_TRACKS

export const UPDATE_STATIC_KEYFRAME = 'UPDATE_STATIC_KEYFRAME'
export type UPDATE_STATIC_KEYFRAME = typeof UPDATE_STATIC_KEYFRAME

export const ACTIVATE_PLUS_BTN = 'ACTIVATE_PLUS_BTN'
export type ACTIVATE_PLUS_BTN = typeof ACTIVATE_PLUS_BTN

export const UPDATE_KEYFRAME_CONTAINER_SLIDER = 'UPDATE_KEYFRAME_CONTAINER_SLIDER'
export type UPDATE_KEYFRAME_CONTAINER_SLIDER = typeof UPDATE_KEYFRAME_CONTAINER_SLIDER

export const UPDATE_SPEC_CHARTS = 'UPDATE_SPEC_CHARTS'
export type UPDATE_SPEC_CHARTS = typeof UPDATE_SPEC_CHARTS

export const UPDATE_SPEC_ANIMATIONS = 'UPDATE_SPEC_ANIMATIONS'
export type UPDATE_SPEC_ANIMATIONS = typeof UPDATE_SPEC_ANIMATIONS

export const UPDATE_DELAY_BETWEEN_KF = 'UPDATE_DELAY_BETWEEN_KF'
export type UPDATE_DELAY_BETWEEN_KF = typeof UPDATE_DELAY_BETWEEN_KF

export const REMOVE_DELAY_BETWEEN_KF = 'REMOVE_DELAY_BETWEEN_KF'
export type REMOVE_DELAY_BETWEEN_KF = typeof REMOVE_DELAY_BETWEEN_KF

export const UPDATE_KF_TIMING_REF = 'UPDATE_KF_TIMING_REF'
export type UPDATE_KF_TIMING_REF = typeof UPDATE_KF_TIMING_REF

export const UPDATE_TIMING_REF_DELAY_KF = 'UPDATE_TIMING_REF_DELAY_KF'
export type UPDATE_TIMING_REF_DELAY_KF = typeof UPDATE_TIMING_REF_DELAY_KF

export const REMOVE_LOWESTGROUP = 'REMOVE_LOWESTGROUP'
export type REMOVE_LOWESTGROUP = typeof REMOVE_LOWESTGROUP

export const UPDATE_DELAY_BETWEEN_GROUP = 'UPDATE_DELAY_BETWEEN_GROUP'
export type UPDATE_DELAY_BETWEEN_GROUP = typeof UPDATE_DELAY_BETWEEN_GROUP

export const REMOVE_DELAY_BETWEEN_GROUP = 'REMOVE_DELAY_BETWEEN_GROUP'
export type REMOVE_DELAY_BETWEEN_GROUP = typeof REMOVE_DELAY_BETWEEN_GROUP

export const MERGE_GROUP = 'MERGE_GROUP'
export type MERGE_GROUP = typeof MERGE_GROUP

export const UPDATE_TIMEING_REF_BETWEEN_GROUP = 'UPDATE_TIMEING_REF_BETWEEN_GROUP'
export type UPDATE_TIMEING_REF_BETWEEN_GROUP = typeof UPDATE_TIMEING_REF_BETWEEN_GROUP

export const UPDATE_DELAY_TIMING_REF_BETWEEN_GROUP = 'UPDATE_DELAY_TIMING_REF_BETWEEN_GROUP'
export type UPDATE_DELAY_TIMING_REF_BETWEEN_GROUP = typeof UPDATE_DELAY_TIMING_REF_BETWEEN_GROUP

export const REMOVE_DELAY_UPDATE_TIMING_REF_GROUP = 'REMOVE_DELAY_UPDATE_TIMING_REF_GROUP'
export type REMOVE_DELAY_UPDATE_TIMING_REF_GROUP = typeof REMOVE_DELAY_UPDATE_TIMING_REF_GROUP

export const UPDATE_DURATION = 'UPDATE_DURATION'
export type UPDATE_DURATION = typeof UPDATE_DURATION

export const UPDATE_ANI_OFFSET = 'UPDATE_ANI_OFFSET'
export type UPDATE_ANI_OFFSET = typeof UPDATE_ANI_OFFSET

export const UPDATE_SUGGESTION_PATH = 'UPDATE_SUGGESTION_PATH'
export type UPDATE_SUGGESTION_PATH = typeof UPDATE_SUGGESTION_PATH

export const UPDATE_SPEC_GROUPING = 'UPDATE_SPEC_GROUPING'
export type UPDATE_SPEC_GROUPING = typeof UPDATE_SPEC_GROUPING

export const REMOVE_CREATE_MULTI_ANI = 'REMOVE_CREATE_MULTI_ANI'
export type REMOVE_CREATE_MULTI_ANI = typeof REMOVE_CREATE_MULTI_ANI

export const SPLIT_CREATE_MULTI_ANI = 'SPLIT_CREATE_MULTI_ANI'
export type SPLIT_CREATE_MULTI_ANI = typeof SPLIT_CREATE_MULTI_ANI

export const SPLIT_CREATE_ONE_ANI = 'SPLIT_CREATE_ONE_ANI'
export type SPLIT_CREATE_ONE_ANI = typeof SPLIT_CREATE_ONE_ANI

export const APPEND_SPEC_GROUPING = 'APPEND_SPEC_GROUPING'
export type APPEND_SPEC_GROUPING = typeof APPEND_SPEC_GROUPING

/*** dragging animation ***/
export const UPDATE_ANI_ALIGN_WITH_ANI = 'UPDATE_ANI_ALIGN_WITH_ANI'
export type UPDATE_ANI_ALIGN_WITH_ANI = typeof UPDATE_ANI_ALIGN_WITH_ANI

export const UPDATE_ANI_ALIGN_AFTER_ANI = 'UPDATE_ANI_ALIGN_AFTER_ANI'
export type UPDATE_ANI_ALIGN_AFTER_ANI = typeof UPDATE_ANI_ALIGN_AFTER_ANI

export const UPDATE_ANI_ALIGN_WITH_KF = 'UPDATE_ANI_ALIGN_WITH_KF'
export type UPDATE_ANI_ALIGN_WITH_KF = typeof UPDATE_ANI_ALIGN_WITH_KF

export const UPDATE_ANI_ALIGN_AFTER_KF = 'UPDATE_ANI_ALIGN_AFTER_KF'
export type UPDATE_ANI_ALIGN_AFTER_KF = typeof UPDATE_ANI_ALIGN_AFTER_KF
/*** end dragging animation ***/

export const UPDATE_ALIGN_MERGE = 'UPDATE_ALIGN_MERGE'
export type UPDATE_ALIGN_MERGE = typeof UPDATE_ALIGN_MERGE

export const UPDATE_EFFECT_TYPE = 'UPDATE_EFFECT_TYPE'
export type UPDATE_EFFECT_TYPE = typeof UPDATE_EFFECT_TYPE

export const UPDATE_EFFECT_EASING = 'UPDATE_EFFECT_EASING'
export type UPDATE_EFFECT_EASING = typeof UPDATE_EFFECT_EASING

export const KEYFRAME_ZOOM_LEVEL = 'KEYFRAME_ZOOM_LEVEL'
export type KEYFRAME_ZOOM_LEVEL = typeof KEYFRAME_ZOOM_LEVEL

export const UDPATE_GROUPING_SORT = 'UDPATE_GROUPING_SORT'
export type UDPATE_GROUPING_SORT = typeof UDPATE_GROUPING_SORT